module.exports = __webpack_public_path__ + "static/media/HP_card_trails_at_lakeside.562ccd66.jpg";